// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"260":"bf3b410e8914e8ceff7e","943":"7e92a5e7bbe4c28eb389"}[chunkId] + ".js";
};